import React, { useState, useEffect, useContext } from 'react';

import _isNil from 'lodash/isNil';

import { QuestionAnswerBlockPropType } from 'components/modules/custom-pages/types/question-answer-block.types';

import QuestionGroupSelector from './components/QuestionGroupSelector';
import { useLatestRefValue } from '../../../../../utils/hooks';
import { QUESTION_ANSWER_BLOCK_ELEMENT_TYPE } from '../../../../constants/types';
import { EditPageElementModalContext } from '../../EditPageElementModal.context';

import './EditQuestionAnswerBlock.scss';

const propTypes = {
  element: QuestionAnswerBlockPropType,
};

const defaultProps = {
  element: {},
};

export default function EditQuestionAnswerBlock({ element }) {
  const { registerCallback, onUpdateElementState, addValidationError, clearValidationErrors } =
    useContext(EditPageElementModalContext);

  const { questionGroup: elementQuestionGroup } = element;
  const [questionGroup, setQuestionGroup] = useState(elementQuestionGroup);

  const latestElementRef = useLatestRefValue(element);

  function onChange(key, nextValue, stateSetter) {
    const currentElement = latestElementRef.current;
    const nextElement = {
      ...currentElement,
      [key]: nextValue,
    };

    stateSetter(nextValue);
    onUpdateElementState(QUESTION_ANSWER_BLOCK_ELEMENT_TYPE, nextElement);
  }

  function onQuestionGroupChange(nextValue) {
    onChange('questionGroup', nextValue, setQuestionGroup);
  }

  function onSaveContent() {
    return latestElementRef.current;
  }

  useEffect(() => {
    clearValidationErrors();
    if (_isNil(questionGroup)) {
      addValidationError('Question Group must not be empty.');
    }
  }, [questionGroup]);

  useEffect(() => {
    registerCallback(QUESTION_ANSWER_BLOCK_ELEMENT_TYPE, onSaveContent);
  }, []);

  return (
    <div className="edit-question-answer-block">
      <div className="text-block-field name">
        <QuestionGroupSelector
          questionGroup={questionGroup}
          onQuestionGroupChange={onQuestionGroupChange}
        />
      </div>
    </div>
  );
}

EditQuestionAnswerBlock.propTypes = propTypes;
EditQuestionAnswerBlock.defaultProps = defaultProps;
